<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { useClaimStore, useNotificationStore } from '@/store';
import adminAPI from '../../services/api';
import DotLegalStep from '../ui/badges/DotLegalStep.vue';
import BaseButton from '../ui/buttons/BaseButton.vue';
import { RetrieveClaimWithRelationsResponse } from '@upclaim/sdk/src/data-contracts';
import GenerateLegalSubpeona from '../overview/GenerateLegalSubpeona.vue';
import ClaimDocuments from '../overview/ClaimDocuments.vue';
import Alert from '../ui/alerts/Alert.vue';
// import { claimEventTypesByType } from '@/utils/config/constants';

const props = defineProps<{
  claim: RetrieveClaimWithRelationsResponse;
}>();

// const claimId = ref(props.claim?.id);
const legalSubpeona = ref();
const isLoading = ref(true);

// const event = claimEventTypesByType("UPCLAIM.MED_SENT");
// async function addEvent() {
//   await adminAPI.addEvent(props.claim.id, { machineEvent: event.machine_source_id });
//   await useClaimStore().refreshClaim();
// }

watch(() => props.claim, async (claim) => {
  if (claim) {
    isLoading.value = true;
    legalSubpeona.value = await adminAPI.retrieveLegalSubpeona(claim.id);
    isLoading.value = false;
  }
}, { immediate: true });
</script>
<template>
<div class="border-b bg-slate-50">
  <div class="max-w-lg py-5 mx-auto text-left">
    <div class="p-8 bg-white border rounded-md shadow">
      <h2 class="inline-flex text-base font-semibold leading-6 text-gray-900 align-middle">
        <div class="py-1 mr-2"><DotLegalStep :legal-step-name="useClaimStore().claim.claimLegalStep.name" /></div>
        Actions requises
      </h2>
      <p class="mt-4 text-sm leading-6 text-gray-500">
        <span class="font-semibold leading-8 text-gray-900">Préparer le Projet d'Assignation<br></span>
        <span class="font-semibold text-slate-600">Bien vérifier les demandes (Article 5, 9, 14.2, et demandes supplémentaires).</span>
      </p>

      <pre class="py-4 prose" v-tooltip.bottom="'Ordre des pièces à respecter (pour l\'instant)'">
      
Pièce n°1: 	Extrait K-bis de la société UPCLAIM
Pièce n°2: 	Extrait K-bis de la société [AIRLINE_NAME]
Pièce n°3: 	Réservation confirmée
Pièce n°4: 	Cession de créances entre le Passager - JANCARTHIER
Pièce n°5: 	Cession de créances JANCARTHIER – UPCLAIM
Pièce n°6: 	Email de la société UPCLAIM à la société [AIRLINE_NAME]
Pièce n°7: 	Courrier de mise en demeure de la société UPCLAIM 
Pièce n°8: 	Pièces justificatives
Pièce n°9: 	Pièces justificatives
      </pre>

      <div class="py-6" v-if="!isLoading">
        <div v-if="!legalSubpeona?.legalSubpoenaPdfFileId"  class="relative block py-4 text-sm">
          <div>
            <GenerateLegalSubpeona :claim="claim" :legalSubpeona="legalSubpeona" />
            <ClaimDocuments :claim="claim" />
          </div>
        </div>
        <div v-else>
          <Alert type="success" title="Projet d'assignation détecté" message="Il faut maintenant la transmettre à l'huissier." :with-border="false">
            <div class="mt-4" v-tooltip="'À venir'">
              <BaseButton text="Assignation transmise à l'huissier" />
            </div>
          </Alert>
        </div>
      </div>
    </div>
  </div>
</div>
</template>